import { render, staticRenderFns } from "./accountRegistration.vue?vue&type=template&id=2fbd675a&"
import script from "./accountRegistration.vue?vue&type=script&lang=js&"
export * from "./accountRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports